import { render, staticRenderFns } from "./ForwardSimulations.vue?vue&type=template&id=70bbd6d9&scoped=true"
import script from "./ForwardSimulations.vue?vue&type=script&lang=js"
export * from "./ForwardSimulations.vue?vue&type=script&lang=js"
import style0 from "./ForwardSimulations.vue?vue&type=style&index=0&id=70bbd6d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bbd6d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VLazy,VRow,VSpacer})
